<div class="container mt-5">
  @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
      {{apiError}}
    </div>
  }
  <table mat-table [dataSource]="users">

    <ng-container matColumnDef="picture">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"> <img
        src="{{element.picture == '' ? '../../../assets/tiny_yoda.jpg' : element.picture}}" alt=""
      style="height: 25px; width: 25px;"></td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="level">
      <th mat-header-cell *matHeaderCellDef>Level</th>
      <td mat-cell *matCellDef="let element"> {{element.level}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>